import { Fragment } from 'react';
import { useAsync } from 'react-use';

import { useApi } from '@backstage/frontend-plugin-api';
import { Entity } from '@backstage/catalog-model';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { isOwnerOf } from '@backstage/plugin-catalog-react/alpha';
import { TableOptions } from '@backstage/core-components';
import {
  TechDocsCustomHome,
  TabsConfig,
  DocsTableRow,
} from '@backstage/plugin-techdocs';

const options: TableOptions<DocsTableRow> = { emptyRowsWhenPaging: false };
const isToolkitDoc = (entity: Entity) =>
  ['devops-central', 'engineering-hub', 'sonarqube'].includes(
    entity.metadata.name,
  );

export function MedidataTechDocsHome() {
  const catalogApi = useApi(catalogApiRef);
  const { value: team119entity } = useAsync(
    async () => await catalogApi.getEntityByRef('group:default/team-119'),
  );

  const techDocsTabsConfig: TabsConfig = [
    {
      label: 'Featured Docs',
      panels: [
        {
          title: 'Observability & SRE',
          description: 'Documentation recommended by SRE Team 119',
          panelType: 'DocsCardGrid',
          filterPredicate: entity =>
            isOwnerOf(team119entity as Entity, entity) && !isToolkitDoc(entity),
        },
        {
          title: 'Engineering Toolkit Docs',
          description: 'Useful documentation for engineering teams',
          panelType: 'DocsCardGrid',
          filterPredicate: isToolkitDoc,
        },
      ],
    },
    {
      label: 'All Docs',
      panels: [
        {
          title: 'All Documentation',
          description: 'Browse all documentation in the DevOps Central catalog',
          panelType: 'DocsTable',
          filterPredicate: () => true,
          panelProps: {
            PageWrapper: Fragment,
            CustomHeader: Fragment,
            options,
          },
        },
      ],
    },
  ];

  return <TechDocsCustomHome tabsConfig={techDocsTabsConfig} />;
}
